'use client'

import { PhotoIcon } from '@heroicons/react/24/outline'
import { useEbookImageUrlQuery } from '@/generated/graphql'
import { Modal } from '@/Modal'
import { useState } from 'react'
import { LoadingSpinner } from '@/General/LoadingSpinner'

interface ImageDisplayProps {
  imagePath: string
  pageNumber: number
}

export const ImageDisplay = ({ imagePath, pageNumber }: ImageDisplayProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { data: imageUrlData, isLoading } = useEbookImageUrlQuery(
    {
      imagePath,
    },
    {
      enabled: isModalOpen,
    }
  )

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <a
        href="#"
        onClick={e => {
          e.preventDefault()
          handleOpenModal()
        }}
        className="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-500"
        title="View page"
      >
        <PhotoIcon className="w-8 h-8" />
      </a>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={`Page ${pageNumber}`}
      >
        {isLoading ? (
          <div className="flex justify-center items-center py-12">
            <LoadingSpinner />
          </div>
        ) : imageUrlData?.ebookImageURL ? (
          <img
            src={imageUrlData.ebookImageURL}
            alt={`Page ${pageNumber}`}
            className="max-w-full h-auto mx-auto rounded"
          />
        ) : (
          <div className="text-center text-gray-500 py-6">
            No image available
          </div>
        )}
      </Modal>
    </>
  )
}
